import { useMemo } from "react";
import ReactQuill, { Quill } from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import QuillTableBetter from "quill-table-better";
import "quill-table-better/dist/quill-table-better.css";

if (!Quill.imports["modules/table-better"]) Quill.register({ "modules/table-better": QuillTableBetter }, true);

const FONT_SIZES = ["small", false, "large", "huge"];

export function RichEditor({ value, onChange, placeholder = "Start writing…", readOnly = false, minHeight = 320 }) {
  const modules = useMemo(() => ({
    toolbar: readOnly ? false : {
      container: [
        [{ header: [1, 2, 3, false] }, { size: FONT_SIZES }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["blockquote", "code-block", "link", "image"],
        ["table-better"],
        ["clean"],
      ],
    },
    table: false,
    "table-better": { language: "en_US", menus: ["column", "row", "merge", "table", "cell", "wrap", "copy", "delete"], toolbarTable: true },
    keyboard: { bindings: QuillTableBetter.keyboardBindings },
  }), [readOnly]);

  return (
    <div className={`rich-editor rounded-xl border border-slate-200 bg-white overflow-hidden ${readOnly ? "rich-editor-readonly" : ""}`} data-testid="rich-editor">
      <ReactQuill theme="snow" value={value} onChange={onChange} modules={modules} readOnly={readOnly} placeholder={placeholder} style={{ minHeight }} />
    </div>
  );
}

export function RichContent({ html, className = "" }) {
  return <div className={`ql-snow rich-content ${className}`}><div className="ql-editor !p-0" dangerouslySetInnerHTML={{ __html: html || "" }} /></div>;
}
